import React from 'react';
import PropTypes from 'prop-types';
import styles from './Checkbox.module.css';

export const labelPositions = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  HIDDEN: 'HIDDEN',
};

const propTypes = {
  label: PropTypes.string,
  ariaLabel: PropTypes.string,
  ariaLabelledby: PropTypes.string,
  labelPosition: PropTypes.oneOf([labelPositions.RIGHT, labelPositions.LEFT, labelPositions.HIDDEN]),
  onChange: PropTypes.func,
};

export default function Checkbox(props) {
  const { label, ariaLabel, ariaLabelledby, labelPosition, onChange, ...checkboxProps } = props;

  const getContainerClasses = () => {
    switch (labelPosition) {
      case labelPositions.LEFT:
        return `${styles.container} ${styles['label-on-left']}`;
      case labelPositions.HIDDEN:
        return `${styles.container} ${styles['hide-label']}`;
      default:
        return styles.container;
    }
  };

  const getAriaProps = () => {
    const properties = {};
    if (ariaLabelledby) {
      properties['aria-labelledby'] = ariaLabelledby;
    }
    if (ariaLabel) {
      properties['aria-label'] = ariaLabel;
    }
    if (!ariaLabelledby && !ariaLabel) {
      properties['aria-label'] = label;
    }
    return properties;
  };

  return (
    <label className={getContainerClasses()}>
      <input type="checkbox" className={styles.toggle} onChange={onChange} {...getAriaProps()} {...checkboxProps} />
      <span className={styles.label} aria-hidden="true">
        {label}
      </span>
    </label>
  );
}

Checkbox.defaultProps = {
  label: '',
  labelPosition: labelPositions.RIGHT,
  onChange: () => {},
};

Checkbox.propTypes = propTypes;
